import { useTranslation } from 'react-i18next';
import { Footer, FooterLinkTexts, Header } from '@britishcouncil/react-extro-ui';
import { HeaderBar } from './headerBar';
import CommonLayout from './layout/commonLayout/CommonLayout';
import SkeletonLoader from './SkeletonLoader';
import { useBootPlaceholder } from '../utils/initialLoader';

interface Props {
  alignCenter?: boolean;
  logoUrl: string;
}

const CheckoutSkeleton = ({ alignCenter, logoUrl }: Props) => {
  useBootPlaceholder();
  const { t } = useTranslation(['npp']);

  const linkCustomTexts: FooterLinkTexts = {
    accessibility: t('npp:general.footer.accessibility'),
    dataProtection: t('npp:general.footer.dataProtection'),
    privacyAndCookies: t('npp:general.footer.privacyAndCookies'),
    termsOfUse: t('npp:general.footer.termsOfUse'),
  };

  return (
    <>
      <Header slogan={t('npp:general.checkout')} logoUrl={logoUrl} />
      <HeaderBar />
      <CommonLayout alignCenter={alignCenter} mainSection={<SkeletonLoader />} />
      <Footer linkCustomTexts={linkCustomTexts} />
    </>
  );
};

export default CheckoutSkeleton;
